import {
  Icon,
  Menu,
  Position,
  Tooltip,
  type IconName,
} from "@blueprintjs/core";
import * as React from "react";
import { Link, useMatch } from "react-router-dom";
import { useRoles } from "../hooks/useRoles";
import "./AppsMenu.scss";
import { focusOcApps } from "./sideBarItems";

type LinkedMenuItemProps = {
  text: string;
  to: string;
  icon: IconName;
  collapsed: boolean;
} & React.HTMLAttributes<HTMLDivElement>;

const LinkedMenuItem = ({ text, to, icon, collapsed }: LinkedMenuItemProps) => {
  const match = useMatch({ path: `${to}`, end: false });

  const isActive = match !== null;

  const baseClass = collapsed
    ? "focus-lateral-item-collapsed"
    : "bp4-popover-dismiss";
  return (
    <li>
      <Tooltip
        content={text}
        targetClassName="focus-full-width"
        position={Position.RIGHT}
        boundary="viewport"
        hoverOpenDelay={500}
        hoverCloseDelay={150}
      >
        <Link
          to={to}
          className={`focus-lateral-item ${baseClass} ${
            isActive ? "focus-lateral-active" : ""
          }`}
        >
          <Icon className="focus-menu-icon" size={20} icon={icon} />
          {collapsed ? "" : text}
        </Link>
      </Tooltip>
    </li>
  );
};

export interface AppDescription {
  link: string;
  icon: IconName;
  text: string;
  id: string;
  required: string[];
}

interface AppsMenuProps {
  collapsed: boolean;
}

export const AppsMenu: React.FC<AppsMenuProps> = ({ collapsed }) => {
  const { roles } = useRoles();

  const accessibleApps = focusOcApps.filter((app) =>
    app.required.some((r) => [...roles].includes(r)),
  );

  if (accessibleApps.length < 1) return null;

  return (
    <Menu
      className={`full-height focus-lateral-menu ${collapsed ? "collapsed" : ""}`}
    >
      {accessibleApps.map((app) => (
        <LinkedMenuItem
          key={app.text}
          to={app.link}
          icon={app.icon}
          collapsed={collapsed}
          text={app.text}
        />
      ))}
    </Menu>
  );
};
